export type ReportPropertyOption = { value: string; label: string }

const asText = (value: unknown) => typeof value === 'string' ? value.trim() : ''

// The report needs the AI config ID, not a company name or a users-service property ID.
export const getEnhancedReportProperties = (response: unknown): ReportPropertyOption[] => {
    let value = response
    for (let depth = 0; depth < 4 && value && !Array.isArray(value) && typeof value === 'object'; depth += 1) {
        const record = value as Record<string, unknown>
        value = record.data ?? record.elements
    }
    if (!Array.isArray(value)) return []
    const properties = new Map<string, ReportPropertyOption>()
    value.forEach((item: unknown) => {
        if (!item || typeof item !== 'object') return
        const record = item as Record<string, unknown>
        const scenario = record.scenario as { parentId?: unknown } | undefined
        if (scenario?.parentId) return
        const id = asText(record._id) || asText(record.id) || asText(record.configId)
        const label = asText(record.propertyName) || asText(record.companyName) || asText(record.property) || asText(record.name)
        if (id && label) properties.set(id, { value: id, label })
    })
    return Array.from(properties.values()).sort((a, b) => a.label.localeCompare(b.label))
}
